import "core-js/modules/es6.reflect.construct.js";
import _classCallCheck from "/builds/timeneye/panel-front-end/node_modules/@babel/runtime-corejs2/helpers/classCallCheck.js";
import _createClass from "/builds/timeneye/panel-front-end/node_modules/@babel/runtime-corejs2/helpers/createClass.js";
import _inherits from "/builds/timeneye/panel-front-end/node_modules/@babel/runtime-corejs2/helpers/inherits.js";
import _possibleConstructorReturn from "/builds/timeneye/panel-front-end/node_modules/@babel/runtime-corejs2/helpers/possibleConstructorReturn.js";
import _getPrototypeOf from "/builds/timeneye/panel-front-end/node_modules/@babel/runtime-corejs2/helpers/getPrototypeOf.js";
import _defineProperty from "/builds/timeneye/panel-front-end/node_modules/@babel/runtime-corejs2/helpers/defineProperty.js";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

// User Model
import Vue from 'vue';
import VuexORM from '@vuex-orm/core';
import ApprovalEvent from "./ApprovalEvent";
import User from "./User";
import { APPROVAL_REQUEST_STATUSES } from 'src/boot/constants';
import moment from 'moment';

var ApprovalRequest = /*#__PURE__*/function (_VuexORM$Model) {
  _inherits(ApprovalRequest, _VuexORM$Model);

  var _super = _createSuper(ApprovalRequest);

  function ApprovalRequest() {
    _classCallCheck(this, ApprovalRequest);

    return _super.apply(this, arguments);
  }

  _createClass(ApprovalRequest, null, [{
    key: "entity",
    get: // This is the name used as module name of the Vuex Store.
    function get() {
      return 'approval-requests';
    }
  }, {
    key: "primaryKey",
    get: function get() {
      return ['user_id', 'date_from', 'date_to'];
    }
  }, {
    key: "fields",
    value: // List of all fields (schema) of the post model. `this.attr` is used
    // for the generic field type. The argument is the default value.
    function fields() {
      return {
        approval_request_id: this.attr(null),
        user_id: this.attr(null),
        user: this.belongsTo(User, 'user_id', 'user_id'),
        date_from: this.attr(null),
        date_to: this.attr(null),
        status: this.attr(null),
        total_time: this.attr(null),
        total_expenses: this.attr(null),
        approval_events: this.hasMany(ApprovalEvent, 'approval_request_id')
      };
    }
  }, {
    key: "isDateLockedByApproval",
    value: function isDateLockedByApproval(date, userId) {
      return this.query().where('user_id', userId).where('status', APPROVAL_REQUEST_STATUSES.APPROVED).where(function (approvalRequest) {
        return moment(date).isBetween(moment(approvalRequest.date_from), moment(approvalRequest.date_to), 'day', '[]');
      }).exists();
    }
  }]);

  return ApprovalRequest;
}(VuexORM.Model);

_defineProperty(ApprovalRequest, "state", {
  pending: false
});

_defineProperty(ApprovalRequest, "apiConfig", {
  actions: {
    fetch: function fetch(queryParams) {
      return this.get('/approval-requests', queryParams).then(function (_ref) {
        var response = _ref.response;
        return response;
      });
    },
    fetchById: function fetchById(approvalRequestId) {
      return this.get("/approval-requests/".concat(approvalRequestId)).then(function (_ref2) {
        var response = _ref2.response;
        return response;
      });
    },
    fetchUnsubmitted: function fetchUnsubmitted(queryParams) {
      return this.get('/approval-requests/unsubmitted', queryParams).then(function (_ref3) {
        var response = _ref3.response;
        return response;
      });
    },
    submit: function submit(data) {
      return this.post('/approval-requests', data).then(function (_ref4) {
        var response = _ref4.response;
        // Vue.prototype.$eventHub.$emit('approval-request-updated', response.data)
        return response;
      });
    },
    resubmit: function resubmit(approvalRequestId, data) {
      return this.post("/approval-requests/".concat(approvalRequestId, "/resubmit"), data).then(function (_ref5) {
        var response = _ref5.response;
        // Vue.prototype.$eventHub.$emit('approval-request-updated', response.data)
        return response;
      });
    },
    approve: function approve(approvalRequestId, data) {
      return this.post("/approval-requests/".concat(approvalRequestId, "/approve"), data).then(function (_ref6) {
        var response = _ref6.response;
        // Vue.prototype.$eventHub.$emit('approval-request-updated', response.data)
        return response;
      });
    },
    reject: function reject(approvalRequestId, data) {
      return this.post("/approval-requests/".concat(approvalRequestId, "/reject"), data).then(function (_ref7) {
        var response = _ref7.response;
        // Vue.prototype.$eventHub.$emit('approval-request-updated', response.data)
        return response;
      });
    },
    withdraw: function withdraw(approvalRequestId, data) {
      return this.post("/approval-requests/".concat(approvalRequestId, "/withdraw"), data).then(function (_ref8) {
        var response = _ref8.response;
        // Vue.prototype.$eventHub.$emit('approval-request-updated', response.data)
        return response;
      });
    },
    massApprove: function massApprove(data) {
      return this.post('/approval-requests/mass-approve', data).then(function (_ref9) {
        var response = _ref9.response;
        Vue.prototype.$eventHub.$emit('approval-request-updated', response.data);
        return response;
      });
    },
    sendEmailReminder: function sendEmailReminder(data) {
      return this.post('/approval-requests/remind-submission', data).then(function (_ref10) {
        var response = _ref10.response;
        return response;
      });
    }
  }
});

export { ApprovalRequest as default };